import { FC, useEffect, useState } from "react";
import classNames from "classnames";
import { observer } from "mobx-react-lite";
import { useHistory } from "react-router-dom";
import { withResizeDetector } from "react-resize-detector";
import { authStore } from "../store/authStore";
import { DraggableModal, ITooltip } from "../ui-kit";
import BellNotification from "../components/BellNotification/index";
import { ProfileIco, ExitIco, InstructionIco } from "../assets/customIcons";
import DateTimeInformer from "./common/DateTime";
import Breadcrumbs from "./common/Breadcrumbs";
import ProfileSettings from "./common/Profile";
import TechInfo from "./common/TechInfo";
import GenerateExcelReport from "../components/GenerateExcelReport/index";
import Constants from "../constants/Common";
import styles from "./styles/Header.module.scss";
import { Link } from "react-router-dom";

import axios from "axios";

interface IHeader {
  collapsed: boolean;
  getHeight: (val: number) => void;
  height?: number;
}

const Header: FC<IHeader> = observer((props) => {
  const {
    titleIcons: { profile, exit },
  } = Constants;
  const { height, getHeight, collapsed } = props;
  const history = useHistory();
  const [profileVisible, setProfileVisible] = useState(false);
  const handleExit = async () => {
    authStore.logout(history);
    if (authStore.isEsiaEnabled) {
      const res = await authStore.getLogoutUrl();
      location.assign(res.data);
    }
  };

  const download = () => {
    axios
      .get("/UserManual", {
        responseType: "arraybuffer",
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Руководство пользователя.pdf");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      });
  };

  useEffect(() => {
    if (height) {
      getHeight(height);
    }
  }, [height]);

  return (
    <div
      className={classNames(
        styles.Header,
        !collapsed && styles.HeaderCollapsed,
      )}
    >
      <Breadcrumbs />

      <div className={styles.HeaderAside}>
        <TechInfo />
        <DateTimeInformer />
        <Link to="/pdf/GIS_IS_UserManual.zip" target="_blank" download>
          <ITooltip
            title={"Скачать руководство пользователя"}
            placement="right"
          >
            <InstructionIco />
          </ITooltip>
        </Link>
        <div className={styles.UserInfo}>
          {authStore && <BellNotification />}
          {authStore && <GenerateExcelReport />}
          <div
            onClick={() => {
              if (authStore?.userProfile) setProfileVisible(!profileVisible);
            }}
            className={styles.UserIcon}
          >
            <ITooltip title={profile} placement="right">
              <ProfileIco />
            </ITooltip>
          </div>
          {authStore && (
            <div className={styles.UserInfoName}>
              <div>{authStore.userProfile?.surname}</div>
              <span>
                {authStore.userProfile?.name}&nbsp;
                {authStore.userProfile?.patronymic}
              </span>
            </div>
          )}
        </div>
        <ITooltip title={exit} placement="right">
          <ExitIco onClick={handleExit} />
        </ITooltip>
      </div>
      <DraggableModal
        visible={profileVisible}
        title="Профиль пользователя"
        footer={null}
        style={{
          right: `20px`,
          top: `50px`,
          position: "absolute",
        }}
        onCancel={() => {
          setProfileVisible(false);
        }}
      >
        <ProfileSettings />
      </DraggableModal>
    </div>
  );
});

export default withResizeDetector(Header);
